import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import loginReducer from "./reducers/loginRedux";
import profileReducer from "./reducers/profileRedux";
import usersReducer from "./reducers/master/allusersRedux";
import userEditReducer from "./reducers/admin/editUserRedux";
import createUserReducer from "./reducers/admin/createUserRedux";
import companiesReducer from "./reducers/master/companiesRedux";
import companyEditReducer from "./reducers/master/editCompanyRedux";
import createCompanyReducer from "./reducers/master/createCompanyRedux";
import devicesReducer from "./reducers/admin/devicesRedux"
import eMetersReducer from "./reducers/admin/energyMetersRedux"
import deviceEditReducer from "./reducers/admin/editDeviceRedux"
import createDeviceReducer from "./reducers/admin/createDeviceRedux"
import dataReducer from "./reducers/data/dataRedux"
import passPoliciesReducer from "./reducers/master/passPoliciesRedux"
import createWidgetReducer from "./reducers/widgetRedux"
import createReportReducer from "./reducers/reportRedux"
import healthSafetyReducer from "./reducers/healthSafetyRedux"
import supplierReducer from './reducers/master/suppliersRedux';
import suppliersOfficeReducer from './reducers/master/suppliersOfficeRedux';
import editSupplierReducer from './reducers/master/editSupplierReducer';
import createSupplierReducer from  './reducers/master/createSupplierReducer';
import equiposReducer from './reducers/master/equiposRedux';
import equipoEditReducer from './reducers/master/editEquipoRedux';
import parametrosReducer from './reducers/master/parametrosRedux';
import getSuggestions from "./reducers/suggestions/suggestionsRedux"
import getMesagges from "./reducers/mesagges/mesaggesRedux"
import basicParametersReducer from "./reducers/admin/basicParametersRedux";
import calculatedParameters from "./reducers/admin/calculatedParametersRedux";
import dataEbmReducer from "./reducers/admin/ebmDataRedux";
import itemBills from './reducers/admin/itemBills';
import editItemBills from './reducers/admin/editItemBills';
import uploadPdfBill from './reducers/admin/uploadBillReducer';
import maximetroReducer from "./reducers/data/maximetroRedux";
import loggersReducer from "./reducers/master/loggersReducer";
import forgotpassword from "./reducers/forgotPass/forgot_passRedux";
import alertEventsReducer from "./reducers/alertEventsRedux";
import alerts from "./reducers/alertsRedux";
import loadDemandedReducer from "./reducers/analysis/loadDemandedRedux";
import analysisReducer from "./reducers/analysis/analysisRedux";
import passiveLoadReducer from "./reducers/analysis/passiveLoadRedux";
import notificationsReducer from "./reducers/notifications/notificationsRedux";
import communicationNotificationsReducer from "./reducers/communicationNotificationsRedux";
import invoicePenaltyUserNotificationsReducer from "./reducers/invoicePenaltyUserNotificationsReducer";
import newsReducer from "./reducers/newsRedux";
import documentsReducer from "./reducers/documents/documentsRedux";
import powerSystemMonitoringReducer from "./reducers/powerSystemMonitoringRedux";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ['suppliersOffice', 'createSupplierReducer', 'forgotPassword', 'passPolicies', "dataEbm", "data", "passiveLoad", "loggers", "suggestions", "invoicePenaltyUserNotifications", "communicationNotifications", "news", "powerSystemMonitoring"],
};

const rootReducer = combineReducers({
  user: loginReducer,
  profile: profileReducer,
  users: usersReducer,
  userEdit: userEditReducer,
  userCreate: createUserReducer,
  companies: companiesReducer,
  companyEdit: companyEditReducer,
  companyCreate: createCompanyReducer,
  devices: devicesReducer,
  eMeters: eMetersReducer,
  deviceEdit: deviceEditReducer,
  deviceCreate: createDeviceReducer,
  data: dataReducer,
  passPolicies: passPoliciesReducer,
  board: createWidgetReducer,
  report: createReportReducer,
  healthSafety: healthSafetyReducer,
  suggestions: getSuggestions,
  mesagges : getMesagges,
  supplier: supplierReducer,
  supplierEdit: editSupplierReducer,
  supplierOffice: suppliersOfficeReducer,
  supplierCreate: createSupplierReducer,
  equipos: equiposReducer,
  equipoEdit: equipoEditReducer,
  parametros: parametrosReducer,
  parametersBasics : basicParametersReducer,
  parametrosCalculados : calculatedParameters,
  dataEbm : dataEbmReducer,
  itemsBill: itemBills,
  editItemBill: editItemBills,
  pdfBill: uploadPdfBill,
  maximetro: maximetroReducer,
  loggers: loggersReducer,
  forgotPassword : forgotpassword,
  alertEvents: alertEventsReducer,
  alerts: alerts,
  loadDemanded: loadDemandedReducer,
  analysis: analysisReducer,
  passiveLoad: passiveLoadReducer,
  notifications: notificationsReducer,
  communicationNotifications: communicationNotificationsReducer,
  invoicePenaltyUserNotifications: invoicePenaltyUserNotificationsReducer,
  news: newsReducer,
  documents: documentsReducer,
  powerSystemMonitoring: powerSystemMonitoringReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: { warnAfter: 128 },
    }),
});

export let persistor = persistStore(store);
